<template>
  <div class="index-view-layout">
    <div class="top-row">
      <div class="search-field-container" v-if="searchable">
        <bdg-search-field @search="$emit('search', $event)" />
      </div>

      <div class="new-button-container" v-if="!shouldHideButton">
        <bdg-button
          class="w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square fa-fw"
          @click.native="openSideDrawer()"
        >
          new {{ dataName }}
        </bdg-button>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
import BdgSearchField from "../../forms/fields/BdgSearchField";

export default {
  name: "IndexViewLayout",
  components: { BdgSearchField, BdgButton },
  props: {
    sideDrawerComponent: { type: Object, default: null },
    dataName: { type: String, required: true },
    searchable: { type: Boolean, default: false },
    shouldHideButton: { type: Boolean }
  },
  computed: {
    sideDrawerData() {
      return this.$store.state.createEditComponentData;
    }
  },
  watch: {
    sideDrawerData(val) {
      if (val && this.sideDrawerComponent) {
        this.openSideDrawer();
      }
    }
  },
  methods: {
    openSideDrawer() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: this.sideDrawerComponent,
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.index-view-layout {
  @apply flex flex-col justify-between w-full py-6;

  @screen md {
    @apply px-12 py-16;
  }

  .top-row {
    @apply flex flex-col-reverse justify-between items-center mb-8;

    @screen md {
      @apply flex-row;
    }

    .search-field-container {
      @apply flex justify-center items-center w-full mt-8 px-4;

      @screen md {
        @apply justify-start w-1/4 min-w-64 mt-0 px-0;
      }
    }

    .new-button-container {
      @apply flex justify-center items-center w-full px-4;

      @screen md {
        @apply justify-start w-auto min-w-64 px-0;
      }
    }
  }
}
</style>
